import src from "IMAGE";
export default { src, width: 1920, height: 384, blurWidth: 8, blurHeight: 2, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAYAAABllJ3tAAAAQElEQVR42hXKSwoAIQwDUG0FS+lnuhCP4N77H27i2ySEtAGZud39IG9V3Yg4ZraZeTQi6iIyVfXDuHBcr0/o8AN0uwMXNo2FdQAAAABJRU5ErkJggg=="};
